export const DATA_FINANCE_FARMGATE_GRAPH = '/finance/farmgate-graph';